export { default } from '@triptyk/ember-utils/decorators/disable-in-fastboot';
